import { render, staticRenderFns } from "./ActivityArtwork.vue?vue&type=template&id=5ffd16b9&scoped=true"
import script from "./ActivityArtwork.vue?vue&type=script&lang=js"
export * from "./ActivityArtwork.vue?vue&type=script&lang=js"
import style0 from "./ActivityArtwork.vue?vue&type=style&index=0&id=5ffd16b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd16b9",
  null
  
)

export default component.exports